import { Paged } from 'api/common/types/Page';
import CustomFile from 'common/models/CustomFile';
import Http from 'common/services/Http';
import { POLICIES, ROLES } from '../../Config';
import { UserDto } from './models/UserDto';
import { UsersSelectItemDto } from './models/UsersSelectItemDto';
import { UserSearchCriteria } from './models/UserSearchCriteria';

class UsersService {
    public getList (criteria: UserSearchCriteria) {
        return Http.get<Paged<UserDto>>('users', criteria);
    }

    public getById (id: string) {
        return Http.get<UserDto>('users/' + id);
    }

    public getAllForSelectItem () {
        return Http.get<UsersSelectItemDto[]>('users/get-all-for-select-item');
    }

    public create (model: UserDto, medias: CustomFile[]): Promise<string> {
        return Http.postWithFile('users', model, medias);
    }

    public update (model: UserDto, medias: CustomFile[]) {
        return Http.putWithFile('users', model, medias);
    }

    public remove (model: UserDto) {
        return Http.put('users/deactivate', model);
    }

    public hasPolicies(userPolicies: string[], policies: (keyof typeof POLICIES)[], type: 'OR' | 'AND' = 'AND') {
        const allowed = type === 'AND'
            ? !!((policies || []).map(p => !!(userPolicies || []).find(up => up === p)).length > 0 && (policies || []).map(p => !!(userPolicies || []).find(up => up === p)).filter(p => !p).length === 0)
            : (policies || []).map(p => !!(userPolicies || []).find(up => up === p)).filter(p => p).length > 0;

        return allowed;
    }

    public isPlatformAdmin(userRoles?: string[]) {
        return !!userRoles?.find(x => x === ROLES.PLATFORM_ADMINISTRATOR);
    }

    public isAdmin(userRoles?: string[]) {
        return !!userRoles?.find(x => x === ROLES.ADMINISTRATOR);
    }
}

export default new UsersService();
